import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RespuestaComun } from 'src/app/modal/maestras/respuesta-comun';
import { RespuestaUbigeo } from 'src/app/modal/maestras/respuesta-ubigeo';
import { UbigeoResponseP } from 'src/app/modal/ubigeo/ubigeoResponseP';
import { MaestrasService } from 'src/app/service/maestras/maestras.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import {UsuarioRegistroRequest} from 'src/app/modal/usuario/usuario-registro-request';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { UsuarioRequest } from 'src/app/modal/usuario/usuario-request';
import { Router } from '@angular/router';
import { UsuarioBeanResponse } from 'src/app/modal/usuario/usuario-bean-response';
import { DatePipe } from '@angular/common';
import {ActualizarDatosRequest} from 'src/app/modal/usuario/actualizar-datos-request';
import { UbigeoResponse } from 'src/app/modal/ubigeo/ubbigeoResponse';
import { UbigeoService } from 'src/app/service/ubigeo/ubigeo.service';

@Component({
  selector: 'app-datos-personales',
  templateUrl: './datos-personales.component.html',
  styleUrls: ['./datos-personales.component.scss']
})
export class DatosPersonalesComponent implements OnInit {

  registrarForm: FormGroup;
  listTipoDocumento:RespuestaComun;
  registrarRequest:ActualizarDatosRequest;
  datosUsuario:UsuarioBeanResponse;
  maxLengthTxtNroDocumento:number=15; // Valor por defecto (máximo permitido)
  acceptAdditionalDataTreatment: boolean = false;
  showModalTratamientoDatos: boolean = false;
  initialAcceptAdditionalDataTreatment: boolean = false; // Valor inicial para detectar cambios
  privacyChanged: boolean = false; // Variable para detectar si el checkbox cambió
  // daet1 ini
  listDepartamento:RespuestaUbigeo;
  listProvincia:RespuestaUbigeo;
  listDistrito:RespuestaUbigeo;
  cboDistrito:String;
  cboProvincia:String;
  public stepOneForm: FormGroup;
  cboDepartamentoVal:String;
  // daet1 ini

  public departamento: UbigeoResponse;
  public provincia: UbigeoResponse;
  public distritoResponse: UbigeoResponse;

  //@ViewChild(LoginComponent) loginComponent:LoginComponent;

  constructor(private routerLink:Router,private fb: FormBuilder,private maestraService:MaestrasService,private ubigeoService:UbigeoService,private utilService:UtilitarioService,private usuarioService:UsuarioService, private cdr: ChangeDetectorRef) {
  this.createForm();
  }

  get cboDepartamentoValidar() {return this.stepOneForm.get('cboDepartamentoValidar');}
  get cboProvinciaValidar() {return this.stepOneForm.get('cboProvinciaValidar');}
  get cboDistritoValidar() {return this.stepOneForm.get('cboDistritoValidar');}
  


  createForm(){
    this.registrarForm = this.fb.group({

      txtCorreo:['', [Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      txtNombre:['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/)]],
      txtApellidos:['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/)]],
      txtTipoDocumento:['',Validators.required],
      txtNroDocumento:['',Validators.required],
      txtFechaNacimiento:['',Validators.required],
      txtTelefono:['', [Validators.required, Validators.minLength(7), Validators.maxLength(15), Validators.pattern(/^[0-9+\-\s()]+$/)]],
      txtPasswordActual:['', [Validators.minLength(6)]],
      txtPassword:['', [Validators.minLength(6)]],
      txtPassword2:['', [Validators.minLength(6)]],
      // daet1 ini
      txtDepartamento:['',Validators.required],
      txtProvincia:['',Validators.required],
      txtDistrito:['',Validators.required],
      txtCodigoPostal:['',], // Campo opcional - no está en el HTML
      // daet1 fin
    });
  }
  displayFieldCss(field: string) {
    if (this.registrarForm.get(field).touched){
      return {
        'is-invalid': this.isFieldValid(field),
        'is-valid': !this.isFieldValid(field)
      };      
    }
  }    
  tipoDeDocumento(){
    this.listTipoDocumento = new RespuestaComun();
    this.maestraService.obtenerMaestra("TIPO_DOCUMENTO").subscribe(data=>{
      this.listTipoDocumento = data;
      //console.log(data);
    })
  }
  valirdarPass(){
    let retorno = true;
    let pass1 = this.registrarForm.get("txtPassword").value;
    let pass2 = this.registrarForm.get("txtPassword2").value;
    if(pass1===pass2){
      retorno = false;
    }
    return retorno;

  }
  formatearFecha(fecha){
    let fechaNac:string="";
    if(fecha!=null){
      var date = new Date(fecha+"T05:00:00Z");
      ////console.log(date);
      var day = date.getDate();
      var month = date.getMonth() + 1; // Since getMonth() returns month from 0-11 not 1-12
      var year = date.getFullYear();
      fechaNac = day+"/"+month+"/"+year;
    //console.log(fechaNac);
    }
    return fechaNac
  }

  actualizarUsuario(){  
    if (this.registrarForm.valid) {
      if(this.valirdarPass()){
        
        this.utilService.toastrError("Contraseñas Incorrectas");
       
        return false;
      }
      
      this.registrarRequest = new ActualizarDatosRequest();
      this.registrarRequest.birthDate = this.formatearFecha(this.registrarForm.get("txtFechaNacimiento").value);
      //this.registrarRequest.email = this.registrarForm.get("txtCorreo").value;
      this.registrarRequest.email = this.datosUsuario.response.list[0].email;
      this.registrarRequest.name = this.registrarForm.get("txtNombre").value;
      this.registrarRequest.surname = this.registrarForm.get("txtApellidos").value;
      this.registrarRequest.typeDocument = this.registrarForm.get("txtTipoDocumento").value;
      this.registrarRequest.passwordOld = this.registrarForm.get("txtPasswordActual").value;
      this.registrarRequest.passwordNew = this.registrarForm.get("txtPassword").value;
      this.registrarRequest.document = this.registrarForm.get("txtNroDocumento").value;
      this.registrarRequest.telephone = this.registrarForm.get("txtTelefono").value;
      // daet1 ini
      this.registrarRequest.department= this.registrarForm.get("txtDepartamento").value;
      this.registrarRequest.province= this.registrarForm.get("txtProvincia").value;
      this.registrarRequest.district= this.registrarForm.get("txtDistrito").value;
      this.registrarRequest.postalcode= this.registrarForm.get("txtCodigoPostal").value;
      // daet1 fin

      this.registrarRequest.acceptAdditionalDataTreatment = this.acceptAdditionalDataTreatment ? '1' : '0';

      if((this.registrarRequest.document.length > 8 ||  this.registrarRequest.document.length < 8) && this.registrarRequest.typeDocument=='1'){
        this.utilService.toastrError("El número de DNI debe ser de 8 dígitos");
        this.utilService.loading=false;
        return false;
      }

      if((this.registrarRequest.document.length > 15) && this.registrarRequest.typeDocument=='2'){
        this.utilService.toastrError("El número de Carnet de Extranjeria no puede ser mayor a 15 dígitos");
        this.utilService.loading=false;
        return false;
      }

      if((this.registrarRequest.document.length > 15) && this.registrarRequest.typeDocument=='3'){
        this.utilService.toastrError("El número de Pasaporte no puede ser mayor a 15 dígitos");
        this.utilService.loading=false;
        return false;
      }
      
      //console.log(this.registrarRequest);
      this.usuarioService.actualizarUsuario(this.usuarioService.obtenerIDSessionUsuario(),this.registrarRequest).subscribe(data=>{
        //console.log(data);
        if(data.response.codeResponse==="0000"){
          this.utilService.toastrSuccess(data.response.response);

          // Actualizar la sesión del usuario en localStorage
          this.usuarioService.actualizarSesionUsuario(
            this.registrarRequest.name,
            this.registrarRequest.surname
          );

          this.createForm();
          this.obtenerInformacion();
        }
        else{
          this.utilService.toastrError(data.response.response);
        }
      })
    }
    else{
      this.validateAllFormFields(this.registrarForm);
      this.mostrarErroresValidacion();
    }

  }

  fc_ValTextDocumento(event: any) {
    const inputChar = String.fromCharCode(event.charCode);
    const tipoDoc = this.registrarForm.get("txtTipoDocumento").value;

    // Permitir teclas de control (Enter, Backspace, etc.)
    if (event.charCode === 0) {
      return true;
    }

    switch (tipoDoc) {
      case "1": // DNI - solo números
        const dniPattern = /[0-9]/;
        if (!dniPattern.test(inputChar)) {
          event.preventDefault();
          return false;
        }
        break;

      case "2": // Carnet de Extranjería - letras y números
      case "3": // Pasaporte - letras y números
        const alfanumPattern = /[a-zA-Z0-9]/;
        if (!alfanumPattern.test(inputChar)) {
          event.preventDefault();
          return false;
        }
        break;

      case "4": // Otro - letras, números y guión
        const otroPattern = /[a-zA-Z0-9\-]/;
        if (!otroPattern.test(inputChar)) {
          event.preventDefault();
          return false;
        }
        break;

      default:
        return true;
    }

    return true;
  }

  onChangeTipoDoc(codigo:String){
    const docControl = this.registrarForm.get('txtNroDocumento');

    switch (codigo) {
      case "1": // DNI Perú
        this.maxLengthTxtNroDocumento = 8;
        docControl.setValidators([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(8),
          Validators.pattern(/^[0-9]{8}$/)
        ]);
        break;
      case "2": // Carnet de Extranjería
        this.maxLengthTxtNroDocumento = 15;
        docControl.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(15),
          Validators.pattern(/^[a-zA-Z0-9]+$/)
        ]);
        break;
      case "3": // Pasaporte
        this.maxLengthTxtNroDocumento = 15;
        docControl.setValidators([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(/^[a-zA-Z0-9]+$/)
        ]);
        break;
      case "4": // Otro documento
        this.maxLengthTxtNroDocumento = 15;
        docControl.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(15),
          Validators.pattern(/^[a-zA-Z0-9\-]+$/)
        ]);
        break;
      default:
        docControl.setValidators([Validators.required]);
        break;
    }

    // Actualizar la validación del control
    docControl.updateValueAndValidity();
  } 

  isFieldValid(field: string) {
    return !this.registrarForm.get(field).valid && this.registrarForm.get(field).touched;
  }

  validarCampo(campo: string) {
    const control = this.registrarForm.get(campo);

    if (!control || control.valid) {
      return;
    }

    const errores = control.errors;

    // Validar campo txtNombre
    if (campo === 'txtNombre' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('El nombre es requerido');
      } else if (errores.pattern) {
        this.utilService.toastrWarning('El nombre solo puede contener letras');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('El nombre debe tener al menos 2 caracteres');
      } else if (errores.maxlength) {
        this.utilService.toastrWarning('El nombre no puede exceder 50 caracteres');
      }
    }

    // Validar campo txtApellidos
    if (campo === 'txtApellidos' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('Los apellidos son requeridos');
      } else if (errores.pattern) {
        this.utilService.toastrWarning('Los apellidos solo pueden contener letras');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('Los apellidos deben tener al menos 2 caracteres');
      } else if (errores.maxlength) {
        this.utilService.toastrWarning('Los apellidos no pueden exceder 50 caracteres');
      }
    }

    // Validar campo txtCorreo
    if (campo === 'txtCorreo' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('El correo es requerido');
      } else if (errores.email || errores.pattern) {
        this.utilService.toastrWarning('Ingrese un correo válido');
      }
    }

    // Validar campo txtTipoDocumento
    if (campo === 'txtTipoDocumento' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('Debe seleccionar un tipo de documento');
      }
    }

    // Validar campo txtNroDocumento
    if (campo === 'txtNroDocumento' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('El número de documento es requerido');
      } else if (errores.pattern) {
        this.utilService.toastrWarning('Formato de documento inválido');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('El documento es muy corto');
      } else if (errores.maxlength) {
        this.utilService.toastrWarning('El documento es muy largo');
      }
    }

    // Validar campo txtTelefono
    if (campo === 'txtTelefono' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('El teléfono es requerido');
      } else if (errores.pattern) {
        this.utilService.toastrWarning('El teléfono solo puede contener números y los símbolos + - ( )');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('El teléfono debe tener al menos 7 dígitos');
      } else if (errores.maxlength) {
        this.utilService.toastrWarning('El teléfono no puede exceder 15 dígitos');
      }
    }

    // Validar campo txtFechaNacimiento
    if (campo === 'txtFechaNacimiento' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('La fecha de nacimiento es requerida');
      }
    }

    // Validar campo txtDepartamento
    if (campo === 'txtDepartamento' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('Debe seleccionar un departamento');
      }
    }

    // Validar campo txtProvincia
    if (campo === 'txtProvincia' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('Debe seleccionar una provincia');
      }
    }

    // Validar campo txtDistrito
    if (campo === 'txtDistrito' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('Debe seleccionar un distrito');
      }
    }

    // Validar campo txtPasswordActual
    if (campo === 'txtPasswordActual' && errores) {
      if (errores.minlength) {
        this.utilService.toastrWarning('La contraseña actual debe tener al menos 6 caracteres');
      }
    }

    // Validar campo txtPassword
    if (campo === 'txtPassword' && errores) {
      if (errores.minlength) {
        this.utilService.toastrWarning('La nueva contraseña debe tener al menos 6 caracteres');
      }
    }

    // Validar campo txtPassword2
    if (campo === 'txtPassword2' && errores) {
      if (errores.minlength) {
        this.utilService.toastrWarning('La confirmación de contraseña debe tener al menos 6 caracteres');
      }
    }
  }   

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  mostrarErroresValidacion() {
    const errores: string[] = [];
    // console.log('Ejecutando mostrarErroresValidacion()');
    // console.log('Formulario válido:', this.registrarForm.valid);
    // console.log('Formulario inválido:', this.registrarForm.invalid);

    // Verificar cada campo y agregar mensajes específicos (sin verificar touched)
    if (this.registrarForm.get('txtCorreo').invalid) {
      if (this.registrarForm.get('txtCorreo').errors?.required) {
        errores.push('El correo es requerido');
      }
      if (this.registrarForm.get('txtCorreo').errors?.email || this.registrarForm.get('txtCorreo').errors?.pattern) {
        errores.push('Ingrese un correo válido');
      }
    }

    if (this.registrarForm.get('txtTipoDocumento').invalid) {
      errores.push('Debe seleccionar un tipo de documento');
    }

    if (this.registrarForm.get('txtNroDocumento').invalid) {
      if (this.registrarForm.get('txtNroDocumento').errors?.required) {
        errores.push('El número de documento es requerido');
      }
      if (this.registrarForm.get('txtNroDocumento').errors?.minlength) {
        errores.push('El documento es muy corto');
      }
      if (this.registrarForm.get('txtNroDocumento').errors?.maxlength) {
        errores.push('El documento es muy largo');
      }
      if (this.registrarForm.get('txtNroDocumento').errors?.pattern) {
        errores.push('Formato de documento inválido');
      }
    }

    if (this.registrarForm.get('txtNombre').invalid) {
      if (this.registrarForm.get('txtNombre').errors?.required) {
        errores.push('El nombre es requerido');
      }
      if (this.registrarForm.get('txtNombre').errors?.minlength) {
        errores.push('El nombre debe tener al menos 2 caracteres');
      }
      if (this.registrarForm.get('txtNombre').errors?.maxlength) {
        errores.push('El nombre no puede exceder 50 caracteres');
      }
      if (this.registrarForm.get('txtNombre').errors?.pattern) {
        errores.push('Solo se permiten letras en el nombre');
      }
    }

    if (this.registrarForm.get('txtApellidos').invalid) {
      if (this.registrarForm.get('txtApellidos').errors?.required) {
        errores.push('Los apellidos son requeridos');
      }
      if (this.registrarForm.get('txtApellidos').errors?.minlength) {
        errores.push('Los apellidos deben tener al menos 2 caracteres');
      }
      if (this.registrarForm.get('txtApellidos').errors?.maxlength) {
        errores.push('Los apellidos no pueden exceder 50 caracteres');
      }
      if (this.registrarForm.get('txtApellidos').errors?.pattern) {
        errores.push('Solo se permiten letras en los apellidos');
      }
    }

    if (this.registrarForm.get('txtTelefono').invalid) {
      if (this.registrarForm.get('txtTelefono').errors?.required) {
        errores.push('El teléfono es requerido');
      }
      if (this.registrarForm.get('txtTelefono').errors?.minlength) {
        errores.push('El teléfono debe tener al menos 7 dígitos');
      }
      if (this.registrarForm.get('txtTelefono').errors?.maxlength) {
        errores.push('El teléfono no puede exceder 15 dígitos');
      }
      if (this.registrarForm.get('txtTelefono').errors?.pattern) {
        errores.push('Formato de teléfono inválido');
      }
    }

    if (this.registrarForm.get('txtFechaNacimiento').invalid) {
      errores.push('La fecha de nacimiento es requerida');
    }

    if (this.registrarForm.get('txtDepartamento').invalid) {
      errores.push('Debe seleccionar un departamento');
    }

    if (this.registrarForm.get('txtProvincia').invalid) {
      errores.push('Debe seleccionar una provincia');
    }

    if (this.registrarForm.get('txtDistrito').invalid) {
      errores.push('Debe seleccionar un distrito');
    }

    if (this.registrarForm.get('txtPasswordActual').invalid) {
      errores.push('La contraseña actual debe tener al menos 6 caracteres');
    }

    if (this.registrarForm.get('txtPassword').invalid) {
      errores.push('La nueva contraseña debe tener al menos 6 caracteres');
    }

    if (this.registrarForm.get('txtPassword2').invalid) {
      errores.push('La confirmación de contraseña debe tener al menos 6 caracteres');
    }

    // Mostrar toast con todos los errores encontrados
    // console.log('Total de errores encontrados:', errores.length);
    // console.log('Errores:', errores);

    if (errores.length > 0) {
      errores.forEach(error => {
        // console.log('Mostrando toast para:', error);
        this.utilService.toastrWarning(error);
      });
    } else {
      // console.log('No se encontraron errores');
    }
  }
  obtenerInformacion(){
    this.datosUsuario = new UsuarioBeanResponse();
    this.usuarioService.obtenerUser(this.usuarioService.obtenerIDSessionUsuario()).subscribe(data=>{
      this.datosUsuario = data;
      this.rellenarDatos();
    })
  }
  formateFechaSet(fecha){
    if(fecha){
    let dateA = fecha;
    var dateParts = dateA.split("/");
  
  // month is 0-based, that's why we need dataParts[1] - 1
    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
   
  
    return new DatePipe('en-US').transform(dateObject , 'yyyy-MM-dd')
    }
    else{
      return ""
    }
  }
  rellenarDatos(){

    this.registrarForm.get("txtCorreo").setValue(this.datosUsuario.response.list[0].email);
    this.registrarForm.get("txtNombre").setValue(this.datosUsuario.response.list[0].name);
    this.registrarForm.get("txtApellidos").setValue(this.datosUsuario.response.list[0].surname);
    this.registrarForm.get("txtTipoDocumento").setValue(this.datosUsuario.response.list[0].typeDocumentId);

    // Actualizar validadores según el tipo de documento
    this.onChangeTipoDoc(this.datosUsuario.response.list[0].typeDocumentId);

    this.registrarForm.get("txtNroDocumento").setValue(this.datosUsuario.response.list[0].document);
    this.registrarForm.get("txtTelefono").setValue(this.datosUsuario.response.list[0].telephone);
    this.registrarForm.get("txtFechaNacimiento").setValue(this.formateFechaSet(this.datosUsuario.response.list[0].birthDate));

    // daet1 ini
    this.registrarForm.get("txtDepartamento").setValue(this.datosUsuario.response.list[0].department);
    // console.log(this.datosUsuario.response.list[0].province);
    this.obtenerProvincia(this.datosUsuario.response.list[0].department);
    this.registrarForm.get("txtProvincia").setValue(this.datosUsuario.response.list[0].province);
    // console.log(this.datosUsuario.response.list[0].district);
    this.obtenerDistritos(this.datosUsuario.response.list[0].department,this.datosUsuario.response.list[0].province);
    this.registrarForm.get("txtDistrito").setValue(this.datosUsuario.response.list[0].district);
    this.registrarForm.get("txtCodigoPostal").setValue(this.datosUsuario.response.list[0].postalCode);
    // daet1 fin

    // Cargar el valor del checkbox de tratamiento de datos adicionales
    // console.log('rellenarDatos - acceptAdditionalDataTreatment del backend:', this.datosUsuario.response.list[0].acceptAdditionalDataTreatment);
    this.acceptAdditionalDataTreatment = this.datosUsuario.response.list[0].acceptAdditionalDataTreatment === '1';
    this.initialAcceptAdditionalDataTreatment = this.acceptAdditionalDataTreatment; // Guardar valor inicial
    this.privacyChanged = false; // Resetear el estado de cambio
    // console.log('rellenarDatos - acceptAdditionalDataTreatment:', this.acceptAdditionalDataTreatment);
    // console.log('rellenarDatos - initialAcceptAdditionalDataTreatment:', this.initialAcceptAdditionalDataTreatment);
    // console.log('rellenarDatos - registrarForm.dirty:', this.registrarForm.dirty);
    // console.log('rellenarDatos - registrarForm.invalid:', this.registrarForm.invalid);

    // Resetear el estado dirty del formulario después de cargar los datos
    this.registrarForm.markAsPristine();
    this.registrarForm.markAsUntouched();
  }

  // Método para verificar si el checkbox de privacidad cambió
  hasPrivacyChanged(): boolean {
    return this.acceptAdditionalDataTreatment !== this.initialAcceptAdditionalDataTreatment;
  }

  // Método para manejar el cambio del checkbox de privacidad
  onPrivacyChange(): void {
    // Actualizar la variable que indica si el checkbox cambió
    this.privacyChanged = this.acceptAdditionalDataTreatment !== this.initialAcceptAdditionalDataTreatment;

    // console.log('=== onPrivacyChange ===');
    // console.log('acceptAdditionalDataTreatment:', this.acceptAdditionalDataTreatment);
    // console.log('initialAcceptAdditionalDataTreatment:', this.initialAcceptAdditionalDataTreatment);
    // console.log('privacyChanged:', this.privacyChanged);
    // console.log('registrarForm.dirty:', this.registrarForm.dirty);
    // console.log('registrarForm.invalid:', this.registrarForm.invalid);
    // console.log('Botón debería estar habilitado:', this.registrarForm.dirty || this.privacyChanged);

    // Si hay campos inválidos, marcarlos para que el usuario los vea
    if (this.registrarForm.invalid && this.privacyChanged) {
      // Marcar todos los campos como touched para mostrar validaciones
      Object.keys(this.registrarForm.controls).forEach(key => {
        const control = this.registrarForm.get(key);
        control.markAsTouched();
        control.updateValueAndValidity();
      });
      this.mostrarErroresValidacion();
    }

    // Forzar detección de cambios
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    this.tipoDeDocumento();
    this.obtenerInformacion();
    //daet1
    this.cboDepartamentoVal = "";
    this.obtenerDepartamento();
    this.provincia = new UbigeoResponse();
    this.distritoResponse = new UbigeoResponse();
    this.stepOneForm = new FormGroup({
      cboDepartamentoValidar: new FormControl('', Validators.required),
      cboProvinciaValidar: new FormControl('', Validators.required),
      cboDistritoValidar: new FormControl('', Validators.required),
    });
  }

  obtenerDepartamento(){
    //this.utilitarioService.loading = true;
    this.departamento = new UbigeoResponse();    
    this.ubigeoService.obtenerDepartamento().subscribe(data=>{
      this.departamento = data;
      //this.utilitarioService.loading = false;
    })
  }

  obtenerProvincia(codDepartamento:String){    
    this.distritoResponse.response.list = [];
    this.provincia = new UbigeoResponse();
    //this.utilitarioService.loading = true;
    this.ubigeoService.obtenerProvincia(codDepartamento).subscribe(data=>{
      this.provincia = data;
      this.cboProvincia = "";
      this.cboDistrito = "";
      //this.utilitarioService.loading = false;
    })
  }

  obtenerDistritos(codDepartamento:String,codProvincia:String){
    // console.log("codDepartamento:"+codDepartamento+"_codProvincia:"+codProvincia);
    this.distritoResponse = new UbigeoResponse();
    //this.utilitarioService.loading = true;
    this.ubigeoService.obtenerDistrito(codDepartamento,codProvincia).subscribe(data=>{
      this.distritoResponse = data;
      this.cboDistrito = "";
      //this.utilitarioService.loading = false;
    })
  }

  onClickTratamientoDatos(){
    this.showModalTratamientoDatos = true;
  }

}
